import {useSelector} from 'react-redux';
import AdminSidebar from './adminSidebar';
import AgentNavigation from './AgentNavigation';
import {usesAgentMenu} from './agentMenuDefinition';
export default function Sidebar(){
 const user=useSelector(s=>s.MyData),screens=useSelector(s=>s.anthScreen),brand=useSelector(s=>s.brand);
 if(!usesAgentMenu(user))return <AdminSidebar/>;
 return <div className="flex overflow-hidden sidebar"><nav className="side-nav" style={{backgroundColor:'#f1f5f9',height:'100dvh',borderRight:'5px solid #fff'}}><AgentNavigation user={user} screens={screens} brand={brand}/></nav></div>;
}
